import React from 'react'
import { useHistory } from 'react-router-dom'
import classNames from 'classnames'
import commonsService from '@/services/commons.service'
import { ReactComponent as DoubleArrowIcon } from '@/assets/icons/double-arrow-icon.svg'
import { ReactComponent as CogIcon } from '@/assets/icons/cog-solid.svg'
import { ReactComponent as UserIcon } from '@/assets/icons/user-solid.svg'
import { ReactComponent as CalculatorIcon } from '@/assets/icons/calculator-solid.svg'
import './SettingsMenu.scoped.sass'
import dropdownService from '@/components/DropdownMenu/dropdown.service'

export function SettingsMenu () {
  const history = useHistory()

  const setSettingsPage = (path) => history.push(`/settings/${path}`)
  const isSelected = (path) => {
    const currentPath = window.location.pathname
    if (!path) {
      const splittedPath = currentPath.split('/')
      const last = splittedPath[splittedPath.length - 1]
      if (last === 'settings') return true
      if (last === '' && splittedPath[splittedPath.length - 2] === 'settings') return true
      return false
    }
    return currentPath.includes(path)
  }

  const getMobileMenuSectionTitle = () => {
    const location = window.location.href
    if (location.includes('/account')) { return 'Account settings' }
    if (location.includes('/billing')) { return 'Billing' }
    return 'Edit profile'
  }

  const onTapMenuHandler = (event) => {
    const iconSize = { width: '18px', height: '18px', color: 'black' }
    event.preventDefault()
    event.stopPropagation()
    const options = [
      {
        icon: <UserIcon style={iconSize} />,
        title: 'Edit Profile',
        action: () => {
          commonsService.goToPage('/settings')
          dropdownService.close()
        },
        color: 'normal'
      },
      {
        icon: <CogIcon style={iconSize} />,
        title: 'Account Settings',
        action: () => {
          commonsService.goToPage('/settings/account')
          dropdownService.close()
        },
        color: 'normal'
      },
      {
        icon: <CalculatorIcon style={iconSize} />,
        title: 'Billing',
        action: () => {
          commonsService.goToPage('/settings/billing')
          dropdownService.close()
        },
        color: 'normal'
      },
    ]
  
    dropdownService.open(options, 'left header', event)
  }

  return (
    <>
      {!commonsService.isMobile()
        ? <div className="settings-menu">
          <ul>
            {[{ label: 'Edit Profile', path: '' },
              { label: 'Account Settings', path: 'account' },
              { label: 'Billing', path: 'billing' },
            ].map((item) => (
              <li
            key={item.label}
            className={classNames({ active: isSelected(item.path) })}
            onClick={() => setSettingsPage(item.path)}>
                {item.label}
              </li>
            ))}
          </ul>
          {/* <ul>
        <li className={isSelected('billing') && 'active'} onClick={() => setSettingsPage('billing')}>Billing</li>
      </ul> */}
        </div>
        : <div className="settings-menu" onClick={onTapMenuHandler}>
          <div className="settings-menu-mobile">
            <div className="settings-menu-mobile-title">{getMobileMenuSectionTitle()}</div>
            <div className="settings-menu-mobile-icon"><DoubleArrowIcon/></div>
          </div>
        </div>}
    </>
  )
}
